/**
 * /cost 等「两种角色都能进」的路由用: 管理员 → AdminLayout, 普通用户 → UserLayout (我的用量)。
 * 其余后台路由仍由 AdminRoute 等守卫拦截, 普通用户进不去。
 */
import { useAuthStore } from "@/stores/auth-store";
import { AdminLayout } from "./AdminLayout";
import { UserLayout } from "./UserLayout";

export function ConsoleLayout() {
  const isAdmin = useAuthStore((s) => s.isAdmin)();
  return isAdmin ? <AdminLayout /> : <UserLayout />;
}
